export default {
    COMPETITOR: 1,
    RELATED: 0,
};
